import styled from "styled-components"
import { Row } from "reactstrap"

const ExerciseRowStyle = styled(Row)`
    padding: 20px 0;
    text-align: justify;
    padding-left: 1rem !important;
    padding-right: 1rem !important;

    .button-collapsed {
        background-color: #66279b;
        border: none;
        color: #FFFFFF;
        padding: 8px;
    }

    @media screen and (min-width: 768px) {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
    }

`

export default ExerciseRowStyle